import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'

const MenopauseSymptomsModal: React.FC = () => {
  const {t} = useTranslation()

  const leftColumnSymptoms = [
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_hot_flashes'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_sudden_wave'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_chest_disco'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_heart_feels'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_low_mood'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_can_include'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_fatigue_or'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_deep_tiredn'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_anxiety'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_feelings_of'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_sleep_chang'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_falling_asl'
      ),
    },
  ]

  const rightColumnSymptoms = [
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_irritabilit'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_things_that'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_vaginal_dry'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_dryness_bur'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_changes_in'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_menopause_c'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_joint_or_mu'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_aches_stiff'
      ),
    },
    {
      title: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_bladder_pro'
      ),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_this_can_me'
      ),
    },
    {
      title: t('help_categories_other'),
      description: t(
        'set_up_profile_menopause_symptoms_menopause_symptoms_modal_other_sympt'
      ),
    },
  ]

  const renderSymptomItem = (symptom: {title: string; description: string}) => (
    <Box key={symptom.title} sx={{mb: {xs: 2, md: 4}}}>
      <PGTypography
        variant='label'
        sx={{
          fontWeight: 600,
          mb: 0.5,
          fontSize: {xs: '0.75rem', md: '0.875rem'},
        }}
      >
        • {symptom.title}:
      </PGTypography>
      <PGTypography
        variant='body'
        sx={{ml: 2, fontSize: {xs: '0.75rem', md: '0.875rem'}}}
      >
        {symptom.description}
      </PGTypography>
    </Box>
  )

  return (
    <Box sx={{pt: {xs: 1, md: 6}, pb: {xs: 2, md: 8}, px: {xs: 2, md: 5}}}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          {leftColumnSymptoms.map(renderSymptomItem)}
        </Grid>
        <Grid item xs={12} md={6}>
          {rightColumnSymptoms.map(renderSymptomItem)}
        </Grid>
      </Grid>
    </Box>
  )
}

export default MenopauseSymptomsModal
